export const environment = {
  production: true,
  identity_provider: 'https://kc-dev.zetra.it',
  realm: 'checkpoint-dev',
  client_id: 'checkpoint-fe',
  baseUrl: 'https://checkpoint-api-dev.zetra.it',
  mediaUrl: 'https://storage-dev.zetra.it/media/checkpoint-dev',
  minioBaseUrl: 'https://storage-dev.zetra.it/media/checkpoint-dev/',
  secureRoutes: ['https://checkpoint-api-dev.zetra.it'],
  version: '1.0.0',
};
